export const formatAmount = (amount: string): string => {
  if (!amount || amount.trim() === "") return "";
  
  // Clean the input
  const cleaned = amount.replace(/[^\d.]/g, '');
  const parts = cleaned.split('.');
  if (parts.length > 2) {
    // Too many decimal points, keep only first one
    return parts[0] + '.' + parts.slice(1).join('');
  }
  
  // If no decimal point, return as-is (don't add .00)
  if (parts.length === 1) {
    return parts[0];
  }
  
  const [integerPart = "", decimalPart = ""] = parts;
  
  // User is typing after decimal, allow up to 2 digits
  if (decimalPart.length <= 2) {
    return `${integerPart || "0"}.${decimalPart}`;
  }
  
  // More than 2 decimal digits, truncate
  return `${integerPart || "0"}.${decimalPart.slice(0, 2)}`;
};

export const removeEmojis = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, "");
};

export const getCategoryInitials = (categoryName: string): string => {
  const words = categoryName.trim().split(/\s+/);
  if (words.length === 1) {
    return words[0].substring(0, 5).toUpperCase();
  } else {
    return words.map((word) => word[0].toUpperCase()).join("");
  }
};
